import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { User } from "@/types/user";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";

const useCurrentUser = () => {
  const userToken = useUserToken();
  return useQuery(
    [ENDPOINTS.me],
    (): Promise<User> =>
      fetch(ENDPOINTS.me, {
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
  );
};

export { useCurrentUser };
